/* eslint-disable */
<template>
  <div class="">

    <div v-show="!fullScreenMode" name="Все кнопки с фильтрами: помещения и переключатели" style="text-align: left;">

      <!-- Строка 1: Помещения -->
      <div class="d-flex flex-wrap">
        <div v-for="section in roomsSections" :key="section" class="m-1">
          <div class="filter-title">{{ section.title }}</div>
          <div class="p-1">
            <div class="list-group">
              <button type="button" v-for="(item, index) in section.rooms" :key="index"
                :class="{ 'room-button list-group-item list-group-item-action active': item.isActive, 'room-button list-group-item list-group-item-action': !item.isActive }"
                @click="handleRoomButtonClick(item)">
                <font-awesome-icon v-if="item.isActive" :icon="['far', 'check-square']" />
                <font-awesome-icon v-if="!item.isActive" :icon="['far', 'square']" />
                {{ item.title }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Строка 2: По стоимости + Возрастная группа -->
      <div class="d-flex flex-wrap">
        <div name="Выбор коммерческого или бесплатного занятия commercials" class="filter-block m-1">
          <div class="filter-title">По стоимости</div>
          <div class="">
            <button v-for="commercial in commercials" :key="commercial" type="button"
              :class="{ 'filter-button btn active m-1': commercial.isActive, 'filter-button btn m-1': !commercial.isActive }"
              @click="handleCommercialButtonClick(commercial.val)">
              <font-awesome-icon :icon="['fas', commercial.icon]" />
              <br>
              {{ commercial.title }}
            </button>
          </div>
        </div>

        <div name="Выбор детских или взрослых занятий kids" class="filter-block m-1">
          <div class="filter-title">Возрастная группа</div>
          <div>
            <button v-for="kid in kids" :key="kid" type="button"
              :class="{ 'filter-button btn active m-1': kid.isActive, 'filter-button btn m-1': !kid.isActive }"
              @click="handleKidButtonClick(kid.val)">
              <font-awesome-icon :icon="['fas', kid.icon]" />
              <br>
              {{ kid.title }}
            </button>
          </div>
        </div>
      </div>

      <!-- Строка 3: Режим отображения строк + Выбор дней недели -->
      <div class="d-flex flex-wrap">
        <div name="Выбор режима просмотра полный средний или минимальный modes" class="filter-block m-1">
          <div class="filter-title">Режим отображения строк</div>
          <div>
            <button v-for="mode in modes" :key="mode" type="button"
              :class="{ 'filter-button btn active m-1': mode.isActive, 'filter-button btn m-1': !mode.isActive }"
              @click="handleModeButtonClick(mode.val)">
              <font-awesome-icon :icon="['fas', mode.icon]" />
              <br>
              {{ mode.title }}
            </button>
          </div>
        </div>

        <div name="Выбор частей недели weekParts" class="filter-block m-1" v-if="computedModeValue !== 'TV ближайшие'">
          <div class="filter-title">Выбор дней недели</div>
          <div>
            <button v-for="wp in computedWeekParts" :key="wp" type="button"
              :class="{ 'filter-button btn active m-1': wp.isActive, 'filter-button btn m-1': !wp.isActive }"
              :disabled="isGeneratingAllPDFs"
              @click="handleWeekPartButtonClick(wp.val)">
              <font-awesome-icon :icon="['fas', wp.icon]" />
              <br>
              {{ wp.title }}
            </button>
          </div>
        </div>
      </div>

      <!-- Строка 4: Выбранные дни недели -->
      <div class="d-flex flex-wrap">
        <div name="Выбранные дни недели selectedDays" class="filter-block m-1" v-if="computedModeValue !== 'TV ближайшие'">
          <div class="filter-title">Выбранные дни недели</div>
          <div>
            <button v-for="day in weekDaysButtons" :key="day.val" type="button"
              :class="{ 'filter-button btn active m-1': day.isActive, 'filter-button btn m-1': !day.isActive }"
              :disabled="isGeneratingAllPDFs"
              @click="handleDayButtonClick(day.val)">
              <font-awesome-icon :icon="['fas', 'calendar-day']" />
              <br>
              {{ day.title }}
            </button>
          </div>
        </div>

        <!-- Настройка количества занятий в строке для TV режима -->
        <div name="Количество занятий в строке TV" class="filter-block m-1" v-if="computedModeValue === 'TV ближайшие'">
          <div class="filter-title">Занятий в строке</div>
          <div>
            <button v-for="count in [1, 2, 3, 4, 5, 6]" :key="count" type="button"
              :class="{ 'filter-button btn active m-1': tvLessonsPerRow === count, 'filter-button btn m-1': tvLessonsPerRow !== count }"
              @click="handleTvLessonsPerRowClick(count)">
              <font-awesome-icon :icon="['fas', 'tv']" />
              <br>
              {{ count }}
            </button>
          </div>
        </div>

        <!-- Настройка масштаба для TV режима -->
        <div name="Масштаб для TV режима" class="filter-block m-1" v-if="computedModeValue === 'TV ближайшие'">
          <div class="filter-title">Масштаб</div>
          <div>
            <button v-for="scale in [0.25, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]" :key="scale" type="button"
              :class="{ 'filter-button btn active m-1': tvScale === scale, 'filter-button btn m-1': tvScale !== scale }"
              @click="handleTvScaleClick(scale)">
              <font-awesome-icon :icon="['fas', 'expand']" />
              <br>
              {{ scale }}x
            </button>
          </div>
        </div>
      </div>

      <!-- Индикатор прогресса генерации PDF -->
      <div v-if="isGeneratingAllPDFs" class="m-3 p-3 bg-light border rounded">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <font-awesome-icon icon="spinner" size="lg" spin />
          </div>
          <div class="flex-grow-1">
            <h6 class="mb-1">Генерация PDF файлов...</h6>
            <div class="progress mb-1" style="height: 20px;">
              <div class="progress-bar bg-success" role="progressbar" 
                   :style="{ width: pdfGenerationProgress + '%' }" 
                   :aria-valuenow="pdfGenerationProgress" 
                   aria-valuemin="0" 
                   aria-valuemax="100">
                {{ pdfGenerationProgress }}%
              </div>
            </div>
            <small class="text-muted">Пожалуйста, не закрывайте страницу до завершения процесса</small>
          </div>
        </div>
      </div>

      <div class="m-2 d-inline-block">Отступ справа при печати: <input v-model="paddingRightPercent"
          style="width: 60px; margin-right:4px;">%</div>
      <button @click="generatePDF()" :disabled="isGeneratingAllPDFs">Генерировать PDF A4 альбом с заданным отступом справа под наши уникальные
        неформальные рамки с отступом {{ paddingRightPercent }}%</button>

      <div class="w-100 fs-4 d-flex pl-4 mt-4" v-if="computedModeValue !== 'TV ближайшие'">
        <button type="button" class="btn btn-outline-secondary"
          @click="weekNumberDecrementButtonClick"><font-awesome-icon :icon="['fas', 'fa-chevron-left']" /></button>
        <div class="mx-2">{{ computedStartDate }} — {{ computedEndDate }}</div>
        <button type="button" class="btn btn-outline-secondary"
          @click="weekNumberIncrementButtonClick"><font-awesome-icon :icon="['fas', 'fa-chevron-right']" /></button>
        <div name="Перечисление выбранных помещений" class="ml-2" style="margin-left: 10px;">
          {{ this.computedAllowedRoomTitles.join(', ') }}
        </div>
        <div class="ms-auto">
          <button class="btn logo-btn" @click="forceRefresh">
            <img v-if="schedule" class="g1logo" :src="require('@/g1logo.png')" alt="Пример изображения">
            <div v-else class="mr-1"><font-awesome-icon icon="spinner" size="lg" spin /></div>
          </button>
        </div>
      </div>
    </div>

    <div v-if="shouldShowLoadingOverlay" class="loading-overlay">
      <div class="loading-card">
        <font-awesome-icon icon="spinner" size="2x" spin />
        <span>Загружаем актуальное расписание...</span>
      </div>
    </div>

    <div name="Печатаемый контент" id="printingContent" v-if="fontSizeVW">
      <div id="contentCenter">
        <!-- Таблица для режима 1/3 недели -->
        <table v-if="computedModeValue === '1/3 недели' || computedModeValue === '1/2 недели'" class="table table-bordered line-height-1-2 mb-4"
          style="table-layout: fixed; width: 100%;">
          <thead class="head-separator">
            <!-- Первая строка: дни недели -->
            <tr>
              <th rowspan="2" class="clock-column-style">
                <button type="button" class="clock-button" @click="toggleFullScreen(true)">
                  <font-awesome-icon :icon="['fas', 'clock']" size="sm" />
                </button>
              </th>
              <th v-for="day in scheduleDays" :key="day" :colspan="scheduleRooms.length"
                class="text-center weekday-header">
                <div>{{ getDateForDay(day) }}</div>
                <div>{{ day }}</div>
              </th>
            </tr>
            <!-- Вторая строка: помещения -->
            <tr>
              <template v-for="day in scheduleDays" :key="day">
                <th v-for="(room, roomIndex) in scheduleRooms" :key="room" class="col-md-1 text-center" :class="[
                  'col-md-1', 'text-center', 'room-header',
                  (roomIndex === scheduleRooms.length - 1) ? 'day-separator' : '',
                  'day-group-bg-' + (scheduleDays.indexOf(day) % 2)
                ]">
                  {{ room }}
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(hourData, hour) in scheduleByHours" :key="hour">
              <td class="clock-column-style day-separator day-group-bg-1">
                {{ hour }}
              </td>
              <template v-for="day in scheduleDays" :key="day">
                <td v-for="(room, roomIndex) in scheduleRooms" :key="room" class="td-container" :class="[
                  'td-container',
                  (roomIndex === scheduleRooms.length - 1) ? 'day-separator' : '',
                  'day-group-bg-' + (scheduleDays.indexOf(day) % 2)
                ]">
                  <div v-if="hourData[day] && hourData[day][room]" class="inner-div">
                    <div v-for="l in hourData[day][room]" :key="l.id || l.startTime + l.exerciseTitle">
                      <div class="lesson-parent m-1" :style="{ border: '1px solid ' + l.backgroundColor }">
                        <div>
                          <div class="exercise-title">{{ l.exerciseTitle }}</div>
                          <div class="trainer-name text-truncate d-inline-block">{{ l.trainerName }}</div>
                          <div class="trainer-name text-truncate d-inline-block">{{ formatDate(l.date) }}</div>
                          <div class="start-end-time">{{ l.startTime }} - {{ l.endTime }}</div>
                        </div>
                        <span class="lesson-color" :style="{ background: l.backgroundColor }"></span>
                        <div v-if="l.exerciseTitle.includes('₽')" class="ruble-icon">
                          <font-awesome-icon :icon="['fas', 'ruble-sign']" size="sm" />
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
            </tr>
          </tbody>
        </table>

        <!-- Контейнер для снежинок (решение из Доки) - вне tv-mode-container чтобы не обрезался overflow -->
        <teleport to="body">
          <div v-if="computedModeValue === 'TV ближайшие' && enableTvSnowflakes" class="snow" :style="{ '--animation-name': snowAnimationName }">
            <div v-for="(flake, index) in snowflakes" :key="index" class="snow__flake">❄</div>
          </div>
        </teleport>
        
        <!-- TV режим - Ближайшие тренировки -->
        <div v-if="computedModeValue === 'TV ближайшие'" class="tv-mode-container">
          <!-- Заголовок с кнопкой управления -->
          <div class="tv-header">
            <div class="tv-title-section">
              <h2 class="tv-main-title">Ближайшие тренировки</h2>
            </div>
            <button type="button" class="tv-control-button" @click="toggleFullScreen(true)">
              <img src="@/G1 ФИТНЕС ПАРК.jpg" alt="G1 Фитнес Парк" class="g1-logo-button" />
            </button>
          </div>
          
          <!-- Список ближайших тренировок -->
          <div class="tv-lessons-wrapper" :style="{ transform: `scale(${tvScale})`, transformOrigin: 'top center', width: computedTvContainerWidth, marginLeft: computedTvMarginLeft }">
            <div class="tv-lessons-container">
              <div v-if="upcomingLessons.length === 0" class="tv-no-lessons">
                <font-awesome-icon :icon="['fas', 'calendar-times']" size="3x" />
                <h3>Нет ближайших тренировок</h3>
                <p>Попробуйте изменить фильтры или выберите другую неделю</p>
              </div>
              <div v-else class="tv-lessons-grid">
                <div v-for="(lesson, index) in upcomingLessons" :key="index" class="tv-lesson-card">
                <div class="tv-lesson-time">
                  <div class="tv-time-main">{{ lesson.startTime }}</div>
                  <div class="tv-time-duration">{{ lesson.endTime }}</div>
                </div>
                <div class="tv-lesson-content">
                  <div class="tv-lesson-title">{{ lesson.exerciseTitle }}</div>
                  <div class="tv-lesson-trainer">{{ lesson.trainerName }}</div>
                  <div class="tv-lesson-date">{{ formatDate(lesson.date) }}</div>
                  <div class="tv-lesson-room">{{ lesson.roomTitle }}</div>
                </div>
                <div class="tv-lesson-indicator" :style="{ backgroundColor: lesson.backgroundColor }"></div>
                <div v-if="lesson.exerciseTitle.includes('₽')" class="tv-ruble-icon">
                  <font-awesome-icon :icon="['fas', 'ruble-sign']" />
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div id="contentRight"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
import axios from 'axios';
import { reactive } from 'vue';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
  name: 'MainComponent',
  data() {
    return {
      excerciseTitleFontSize: '18pt', // Reduced from 20pt to 18pt (10% reduction)
      weekdayHeaderFontSize: '20pt',
      roomHeaderTitleFontSize: '20pt',
      fontSizeVW: '100%',
      paddingRightPercent: 6.4,
      fullScreenMode: false,
      year: 0,
      weekNumber: 0,
      startDate: '',
      endDate: '',
      kids: [
        { title: 'Любые', icon: 'users', val: 'all', isActive: false },
        { title: 'Детские', icon: 'child', val: 'kid', isActive: false },
        { title: 'Взрослые', icon: 'user-tie', val: 'non-kid', isActive: true },
      ],
      commercials: [
        { title: 'Неважно', val: 'all', isActive: true, icon: 'question' },
        { title: 'Платные', val: 'commercial', isActive: false, icon: 'ruble-sign' },
        { title: 'Бесплатные', val: 'non-commercial', isActive: false, icon: 'fa-gift' },
      ],
        modes: [
          { title: '1/3 недели', val: '1/3 недели', isActive: false, icon: 'calendar-week' },
          { title: '1/2 недели', val: '1/2 недели', isActive: true, icon: 'calendar-week' },
          { title: 'TV ближайшие', val: 'TV ближайшие', isActive: false, icon: 'tv' },
        ],
      weekParts: [
        { title: 'Пн, Вт, Ср', icon: 'calendar', val: '0,1,2', isActive: false },
        { title: 'Ср, Чт, Пт', icon: 'calendar', val: '2,3,4', isActive: true },
        { title: 'Пт, Сб, Вс', icon: 'calendar', val: '4,5,6', isActive: false },
        { title: 'Вся неделя', icon: 'calendar', val: '0,1,2,3,4,5,6', isActive: false },
      ],
      schedule: [],
      rooms: [],
      scheduleDays: [],
      scheduleRooms: [],
      roomsSections: [
        {
          "title": "ТЗ и студии",
          "icon": "tz",
          "rooms": [
            { "isActive": false, "title": "Тренажерный зал" },
            { "isActive": false, "title": "Студия пилатес" },
          ]
        },
        {
          "title": "Кроссфит и единоборства",
          "icon": "ring",
          "rooms": [
            { "isActive": false, "title": "Зона кроссфита" },
            { "isActive": false, "title": "Зона единоборств" }
          ]
        },
        {
          "title": "Групповые программы",
          "icon": "gp",
          "rooms": [
            { "isActive": true, "title": "Зал №1" },
            { "isActive": true, "title": "Зал №2" }
          ]
        },
        {
          "title": "Сайкл",
          "icon": "cycle",
          "rooms": [
            { "isActive": false, "title": "Сайкл студия" },
            { "isActive": false, "title": "Студия йоги" },
          ]
        },
        {
          "title": "Бассейны",
          "icon": "bassei",
          "rooms": [
            { "isActive": false, "title": "Аква зона" },
            { "isActive": false, "title": "Малый бассейн" },
          ]
        },
        {
          "title": "Сухой детский 1",
          "icon": "suhoi",
          "rooms": [
            { "isActive": false, "title": "Зал единоборств (ДЕТИ)" },
            { "isActive": false, "title": "Зона кроссфита" },
          ]
        },
        {
          "title": "Сухой детский 2",
          "icon": "suhoi",
          "rooms": [
            { "isActive": false, "title": "Студия 1 (ДЕТИ)" },
            { "isActive": false, "title": "Эстетический зал (ДЕТИ)" }
          ]
        },
      ],
      scheduleByHours: reactive({}),
      upcomingLessons: [],
      tvLessonsPerRow: 3, // Количество занятий в строке для TV режима
      tvScale: 1.0, // Масштаб для TV режима (контролирует высоту блоков)
      isUpdatingInBackground: false, // Флаг фонового обновления
      isLoading: false, // Лоадер для не-TV режимов
      tvCacheTtlMs: 7 * 24 * 60 * 60 * 1000, // 7 дней локального кэша браузера для TV
      enableTvSnowflakes: false, // Временно отключено
      snowflakes: Array(50).fill(null).map((_, i) => i), // Массив индексов для снежинок (50 штук)
      snowAnimationName: 'snowfall', // Имя анимации для снежинок
        testMode: false,
      isGeneratingAllPDFs: false,
      pdfGenerationProgress: 0,
      scheduleByHoursTest: { "7": null, "8": null, "9": { "понедельник": [], "вторник": [{ "exerciseTitle": "ХАТХА YOGA 60", "trainerName": "Шакура  Светлана", "startTime": "09:00", "endTime": "10:00", "hour": 9, "dayOfWeek": "вторник", "dateOfMonth": 9, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#B8C6EA" }], "среда": [], "четверг": [{ "exerciseTitle": "ХАТХА YOGA 60", "trainerName": "Шакура  Светлана", "startTime": "09:00", "endTime": "10:00", "hour": 9, "dayOfWeek": "четверг", "dateOfMonth": 11, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#B8C6EA" }], "пятница": [], "суббота": [{ "exerciseTitle": "СУСТАВНАЯ ГИМНАСТИКА", "trainerName": "Замостьянин Валерий", "startTime": "09:00", "endTime": "10:00", "hour": 9, "dayOfWeek": "суббота", "dateOfMonth": 13, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }], "воскресенье": [] }, "10": { "понедельник": [], "вторник": [{ "exerciseTitle": "STRETCHING", "trainerName": "Рогозинская Елена", "startTime": "10:00", "endTime": "11:00", "hour": 10, "dayOfWeek": "вторник", "dateOfMonth": 9, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#1974CE" }], "среда": [{ "exerciseTitle": "PILATES", "trainerName": "Волкова  Виктория ", "startTime": "10:00", "endTime": "11:00", "hour": 10, "dayOfWeek": "среда", "dateOfMonth": 10, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }], "четверг": [{ "exerciseTitle": "МЕДИТАЦИЯ В ГАМАКАХ ₽*", "trainerName": "Шакура  Светлана", "startTime": "10:00", "endTime": "11:00", "hour": 10, "dayOfWeek": "четверг", "dateOfMonth": 11, "exerciseDuration": 60, "roomTitle": "Студия йоги ", "backgroundColor": "#FFD700" }, { "exerciseTitle": "STRETCHING", "trainerName": "Рогозинская Елена", "startTime": "10:00", "endTime": "11:00", "hour": 10, "dayOfWeek": "четверг", "dateOfMonth": 11, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#1974CE" }], "пятница": [{ "exerciseTitle": "ZUMBA", "trainerName": "Николаенко Анна", "startTime": "10:00", "endTime": "11:00", "hour": 10, "dayOfWeek": "пятница", "dateOfMonth": 12, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#EE82EE" }], "суббота": [{ "exerciseTitle": "ХАТХА YOGA 60", "trainerName": "Шакура  Светлана", "startTime": "10:00", "endTime": "11:00", "hour": 10, "dayOfWeek": "суббота", "dateOfMonth": 13, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#B8C6EA" }], "воскресенье": [] }, "11": { "понедельник": [{ "exerciseTitle": "STRETCHING", "trainerName": "Волкова  Виктория ", "startTime": "11:00", "endTime": "12:00", "hour": 11, "dayOfWeek": "понедельник", "dateOfMonth": 8, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#1974CE" }], "вторник": [{ "exerciseTitle": "UNIFLY ₽", "trainerName": "Заремблюк Наталия", "startTime": "11:00", "endTime": "11:55", "hour": 11, "dayOfWeek": "вторник", "dateOfMonth": 9, "exerciseDuration": 55, "roomTitle": "Студия йоги ", "backgroundColor": "#FFD700" }], "среда": [{ "exerciseTitle": "YOGA HEALTH ₽", "trainerName": "Рогозинская Елена", "startTime": "11:00", "endTime": "12:20", "hour": 11, "dayOfWeek": "среда", "dateOfMonth": 10, "exerciseDuration": 80, "roomTitle": "Студия йоги ", "backgroundColor": "#A6CAF0" }, { "exerciseTitle": "TOTAL MAX & BOSU/FITBALL", "trainerName": "Сысоева Олеся", "startTime": "11:00", "endTime": "11:55", "hour": 11, "dayOfWeek": "среда", "dateOfMonth": 10, "exerciseDuration": 55, "roomTitle": "Зал №1", "backgroundColor": "#FBED9E" }], "четверг": [{ "exerciseTitle": "СУСТАВНАЯ ГИМНАСТИКА", "trainerName": "Замостьянин Валерий", "startTime": "11:00", "endTime": "12:00", "hour": 11, "dayOfWeek": "четверг", "dateOfMonth": 11, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }], "пятница": [{ "exerciseTitle": "UNIFLY ₽", "trainerName": "Заремблюк Наталия", "startTime": "11:00", "endTime": "11:55", "hour": 11, "dayOfWeek": "пятница", "dateOfMonth": 12, "exerciseDuration": 55, "roomTitle": "Студия йоги ", "backgroundColor": "#FFD700" }, { "exerciseTitle": "STRONG NATION", "trainerName": "Николаенко Анна", "startTime": "11:00", "endTime": "12:00", "hour": 11, "dayOfWeek": "пятница", "dateOfMonth": 12, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#D02090" }], "суббота": [], "воскресенье": [{ "exerciseTitle": "PILATES", "trainerName": "Сысоева Олеся", "startTime": "11:00", "endTime": "12:00", "hour": 11, "dayOfWeek": "воскресенье", "dateOfMonth": 14, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }] }, "12": { "понедельник": [{ "exerciseTitle": "UNIFLY ₽", "trainerName": "Заремблюк Наталия", "startTime": "12:00", "endTime": "12:55", "hour": 12, "dayOfWeek": "понедельник", "dateOfMonth": 8, "exerciseDuration": 55, "roomTitle": "Студия йоги ", "backgroundColor": "#FFD700" }, { "exerciseTitle": "ANIMAL FLOW ₽*", "trainerName": "Волкова  Виктория ", "startTime": "12:00", "endTime": "13:00", "hour": 12, "dayOfWeek": "понедельник", "dateOfMonth": 8, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#FFB6C1" }], "вторник": [], "среда": [], "четверг": [{ "exerciseTitle": "PILATES", "trainerName": "Волкова  Виктория ", "startTime": "12:00", "endTime": "13:00", "hour": 12, "dayOfWeek": "четверг", "dateOfMonth": 11, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }], "пятница": [], "суббота": [], "воскресенье": [] }, "13": null, "14": { "понедельник": [], "вторник": [{ "exerciseTitle": "СУСТАВНАЯ ГИМНАСТИКА", "trainerName": "Замостьянин Валерий", "startTime": "14:00", "endTime": "15:00", "hour": 14, "dayOfWeek": "вторник", "dateOfMonth": 9, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }], "среда": [], "четверг": [], "пятница": [], "суббота": [], "воскресенье": [] }, "15": { "понедельник": [], "вторник": [{ "exerciseTitle": "PILATES", "trainerName": "Сысоева Олеся", "startTime": "15:00", "endTime": "16:00", "hour": 15, "dayOfWeek": "вторник", "dateOfMonth": 9, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }], "среда": [{ "exerciseTitle": "ZUMBA GOLD", "trainerName": "Николаенко Анна", "startTime": "15:00", "endTime": "16:00", "hour": 15, "dayOfWeek": "среда", "dateOfMonth": 10, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#EE82EE" }], "четверг": [{ "exerciseTitle": "CIRCL MOBILITY", "trainerName": "Николаенко Анна", "startTime": "15:00", "endTime": "16:00", "hour": 15, "dayOfWeek": "четверг", "dateOfMonth": 11, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }], "пятница": [{ "exerciseTitle": "СУСТАВНАЯ ГИМНАСТИКА", "trainerName": "Замостьянин Валерий", "startTime": "15:00", "endTime": "16:00", "hour": 15, "dayOfWeek": "пятница", "dateOfMonth": 12, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }], "суббота": [], "воскресенье": [] }, "16": null, "17": null, "18": { "понедельник": [], "вторник": [{ "exerciseTitle": "STRONG NATION", "trainerName": "Николаенко Анна", "startTime": "18:00", "endTime": "19:00", "hour": 18, "dayOfWeek": "вторник", "dateOfMonth": 9, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#D02090" }], "среда": [], "четверг": [{ "exerciseTitle": "UNIFLY ₽", "trainerName": "Заремблюк Наталия", "startTime": "18:00", "endTime": "18:55", "hour": 18, "dayOfWeek": "четверг", "dateOfMonth": 11, "exerciseDuration": 55, "roomTitle": "Студия йоги ", "backgroundColor": "#FFD700" }, { "exerciseTitle": "ANIMAL FLOW ₽*", "trainerName": "Николаенко Анна", "startTime": "18:00", "endTime": "19:00", "hour": 18, "dayOfWeek": "четверг", "dateOfMonth": 11, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#FFB6C1" }], "пятница": [{ "exerciseTitle": "ART FUNCTIONAL", "trainerName": "Волкова  Виктория ", "startTime": "18:00", "endTime": "18:55", "hour": 18, "dayOfWeek": "пятница", "dateOfMonth": 12, "exerciseDuration": 55, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }], "суббота": [], "воскресенье": [] }, "19": { "понедельник": [], "вторник": [{ "exerciseTitle": "ZUMBA", "trainerName": "Николаенко Анна", "startTime": "19:00", "endTime": "20:00", "hour": 19, "dayOfWeek": "вторник", "dateOfMonth": 9, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#EE82EE" }], "среда": [{ "exerciseTitle": "UNIFLY ₽", "trainerName": "Заремблюк Наталия", "startTime": "19:00", "endTime": "19:55", "hour": 19, "dayOfWeek": "среда", "dateOfMonth": 10, "exerciseDuration": 55, "roomTitle": "Студия йоги ", "backgroundColor": "#FFD700" }, { "exerciseTitle": "PROPILATES ₽", "trainerName": "Волкова  Виктория ", "startTime": "19:00", "endTime": "19:55", "hour": 19, "dayOfWeek": "среда", "dateOfMonth": 10, "exerciseDuration": 55, "roomTitle": "Зал №1", "backgroundColor": null }], "четверг": [{ "exerciseTitle": "ZUMBA", "trainerName": "Николаенко Анна", "startTime": "19:00", "endTime": "20:00", "hour": 19, "dayOfWeek": "четверг", "dateOfMonth": 11, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#EE82EE" }], "пятница": [{ "exerciseTitle": "STRETCHING", "trainerName": "Волкова  Виктория ", "startTime": "19:00", "endTime": "20:00", "hour": 19, "dayOfWeek": "пятница", "dateOfMonth": 12, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#1974CE" }], "суббота": [], "воскресенье": [] }, "20": { "понедельник": [], "вторник": [{ "exerciseTitle": "CIRCL MOBILITY", "trainerName": "Николаенко Анна", "startTime": "20:00", "endTime": "21:00", "hour": 20, "dayOfWeek": "вторник", "dateOfMonth": 9, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#CCFFCC" }], "среда": [{ "exerciseTitle": "ХАТХА YOGA 60", "trainerName": "Шакура  Светлана", "startTime": "20:00", "endTime": "21:00", "hour": 20, "dayOfWeek": "среда", "dateOfMonth": 10, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#B8C6EA" }], "четверг": [], "пятница": [{ "exerciseTitle": "ХАТХА YOGA 60", "trainerName": "Шакура  Светлана", "startTime": "20:00", "endTime": "21:00", "hour": 20, "dayOfWeek": "пятница", "dateOfMonth": 12, "exerciseDuration": 60, "roomTitle": "Зал №1", "backgroundColor": "#B8C6EA" }], "суббота": [], "воскресенье": [] }, "21": null, "22": null },
      weekDays: ['понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота', 'воскресенье'],
      weekDaysButtons: [
        { title: 'Пн', val: 0, isActive: false },
        { title: 'Вт', val: 1, isActive: false },
        { title: 'Ср', val: 2, isActive: true },
        { title: 'Чт', val: 3, isActive: true },
        { title: 'Пт', val: 4, isActive: true },
        { title: 'Сб', val: 5, isActive: false },
        { title: 'Вс', val: 6, isActive: false },
      ],
    };
  },
  mounted() {
    if (this.testMode == false) {
      // Сначала восстанавливаем состояние фильтров из URL (но не даты)
      this.restoreStateFromUrl(true); // true = пропустить восстановление дат
    }
    
    // Всегда устанавливаем следующую неделю при загрузке (после restoreStateFromUrl)
    this.$nextTick(() => {
      const currentWeekInfo = this.getCurrentWeekNumber();
      const nextWeekInfo = this.getNextWeek(currentWeekInfo.weekNumber, currentWeekInfo.year);
      this.weekNumber = nextWeekInfo.weekNumber;
      this.year = nextWeekInfo.year;
      this.setWeekStartEndDate(this.year, this.weekNumber);
      console.log(`Загружаю для недели №${this.weekNumber} года ${this.year}`);
      console.log(`Диапазон дат: ${this.startDate} — ${this.endDate}`);
      
      if (this.testMode == false) {
        this.fetchData();
      }
    });
    
    // Добавляем обработчик изменения размера окна для TV режима
    this.handleResize = () => {
      if (this.computedModeValue === 'TV ближайшие') {
        this.updateTvScaleFromWindowWidth();
      }
    };
    window.addEventListener('resize', this.handleResize);
    
    // Запускаем эффект снежинок, если активен TV режим
    if (this.computedModeValue === 'TV ближайшие' && this.enableTvSnowflakes) {
      this.$nextTick(() => {
        this.startSnowflakes();
      });
    }
  },
  beforeUnmount() {
    // Удаляем обработчик при размонтировании компонента
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
    // Останавливаем эффект снежинок
    this.stopSnowflakes();
  },
  watch: {
    computedModeValue(newVal) {
      // Запускаем или останавливаем эффект снежинок при переключении режима
      if (newVal === 'TV ближайшие' && this.enableTvSnowflakes) {
        this.$nextTick(() => {
          this.startSnowflakes();
        });
      } else {
        this.stopSnowflakes();
      }
    }
  },
  computed: {
    computedAllowedRoomTitles() {
      let allowedRoomTitles = [];
      this.roomsSections.forEach((curr) => { allowedRoomTitles.push(...curr.rooms.filter(item => item.isActive).map(el => el.title)); });
      return allowedRoomTitles;
    },
    shouldShowLoadingOverlay() {
      return this.computedModeValue !== 'TV ближайшие' && this.isLoading;
    },
    computedStartDate() {
      const options = { day: 'numeric', month: 'long' };
      const date = new Date(this.startDate);
      return date.toLocaleDateString('ru-RU', options);
    },
    computedEndDate() {
      const options = { day: 'numeric', month: 'long' };
      const date = new Date(this.endDate);
      return date.toLocaleDateString('ru-RU', options);
    },
    computedKidValue() {
      return this.kids.find((kid) => kid.isActive).val;
    },
    computedModeValue() {
      return this.modes.find((mode) => mode.isActive).val;
    },
    computedCommercialValue() {
      return this.commercials.find((commercial) => commercial.isActive).val;
    },
    computedWeekPartValue() {
      return this.weekParts.find((wp) => wp.isActive).val;
    },
    computedSelectedDays() {
      return this.weekDaysButtons.filter(day => day.isActive).map(day => day.val);
    },
    computedWeekParts() {
      const baseWeekParts = this.computedModeValue === '1/2 недели' ? [
        { title: 'Пн, Вт, Ср', icon: 'calendar', val: '0,1,2', isActive: false },
        { title: 'Чт, Пт, Сб, Вс', icon: 'calendar', val: '3,4,5,6', isActive: false },
        { title: 'Печать недели', icon: 'print', val: '0,1,2,3,4,5,6', isActive: false },
      ] : [
        { title: 'Пн, Вт, Ср', icon: 'calendar', val: '0,1,2', isActive: false },
        { title: 'Ср, Чт, Пт', icon: 'calendar', val: '2,3,4', isActive: true },
        { title: 'Пт, Сб, Вс', icon: 'calendar', val: '4,5,6', isActive: false },
        { title: 'Печать недели', icon: 'print', val: '0,1,2,3,4,5,6', isActive: false },
      ];
      
      // Определяем активную кнопку на основе выбранных дней
      const selectedDaysStr = this.computedSelectedDays.join(',');
      return baseWeekParts.map(wp => ({
        ...wp,
        isActive: wp.val === selectedDaysStr
      }));
    },
    computedTvContainerWidth() {
      return `${100 / this.tvScale}%`;
    },
    computedTvMarginLeft() {
      // При масштабировании контент становится меньше визуально, но DOM-размер остается
      // Нужно сдвинуть wrapper влево на половину "разницы в ширине"
      // Формула: margin-left = (1 - scale) / (2 * scale) * 100%
      const scale = this.tvScale;
      if (scale !== 1.0) {
        const marginPercent = (1 - scale) / (2 * scale) * 100;
        return `-${marginPercent}%`;
      }
      return '0';
    },
  },
  methods: {
    getTvCacheKey(startDate, endDate) {
      return `tv_schedule_cache_v1:${startDate}:${endDate}`;
    },
    readTvScheduleCache(startDate, endDate) {
      try {
        const raw = localStorage.getItem(this.getTvCacheKey(startDate, endDate));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !Array.isArray(parsed.data)) return null;
        if (!parsed.savedAt || (Date.now() - parsed.savedAt > this.tvCacheTtlMs)) return null;
        return parsed;
      } catch (e) {
        console.warn('Не удалось прочитать TV кэш из localStorage', e);
        return null;
      }
    },
    writeTvScheduleCache(startDate, endDate, data, fetchedAtHuman = '') {
      try {
        if (!Array.isArray(data)) return;
        const payload = {
          data,
          fetchedAtHuman,
          savedAt: Date.now()
        };
        localStorage.setItem(this.getTvCacheKey(startDate, endDate), JSON.stringify(payload));
      } catch (e) {
        console.warn('Не удалось сохранить TV кэш в localStorage', e);
      }
    },
    applyTvScheduleData(data, sourceLabel = '') {
      this.schedule = Array.isArray(data) ? data : [];
      this.rooms = [...new Set(this.schedule.map(item => item.roomTitle))].sort().map(el => { return { isActive: false, title: el } });
      this.applySettings();
      this.updateUrlFromState();
      if (sourceLabel) {
        console.log(sourceLabel);
      }
    },
    toggleFullScreen() {
      this.fullScreenMode = !this.fullScreenMode;
      this.updateUrlFromState();
    },
    weekNumberIncrementButtonClick() {
      const nextWeek = this.getNextWeek(this.weekNumber, this.year);
      this.weekNumber = nextWeek.weekNumber;
      this.year = nextWeek.year;
      this.setWeekStartEndDate(this.year, this.weekNumber);
      this.fetchData();
    },
    weekNumberDecrementButtonClick() {
      const prevWeek = this.getPreviousWeek(this.weekNumber, this.year);
      this.weekNumber = prevWeek.weekNumber;
      this.year = prevWeek.year;
      this.setWeekStartEndDate(this.year, this.weekNumber);
      this.fetchData();
    },
    setWeekStartEndDate(year, weekNumber) {
      // Используем правильную функцию для получения понедельника недели
      const currentWeekStartDate = this.getMondayOfWeek(weekNumber, year);
      const nextWeekStartDate = new Date(currentWeekStartDate);
      nextWeekStartDate.setDate(currentWeekStartDate.getDate() + 7);
      const currentWeekEndDate = new Date(nextWeekStartDate);
      currentWeekEndDate.setSeconds(currentWeekEndDate.getSeconds() - 1);
      this.startDate = this.formatDateToISOStringWithoutMilliseconds(currentWeekStartDate);
      this.endDate = this.formatDateToISOStringWithoutMilliseconds(currentWeekEndDate);
    },
    formatDateToISOStringWithoutMilliseconds(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    },
    getMondayMidnightDate(weekNumber, year) {
      // Используем правильную функцию для получения понедельника недели
      return this.getMondayOfWeek(weekNumber, year);
    },
    getCurrentYear() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      return currentYear;
    },
    getCurrentWeekNumber() {
      // Правильная формула для ISO 8601 недели
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      
      // Находим четверг текущей недели (ISO неделя определяется по четвергу)
      const dayOfWeek = date.getDay();
      const thursday = new Date(date);
      thursday.setDate(date.getDate() + (4 - dayOfWeek + 7) % 7);
      
      // Первый четверг года четверга
      const year = thursday.getFullYear();
      const jan1 = new Date(year, 0, 1);
      const jan1Day = jan1.getDay();
      const firstThursday = new Date(jan1);
      firstThursday.setDate(jan1.getDate() + (4 - jan1Day + 7) % 7);
      
      const weekNumber = Math.floor((thursday - firstThursday) / (7 * 24 * 60 * 60 * 1000)) + 1;
      return { weekNumber, year };
    },
    getNextWeek(weekNumber, year) {
      // Получаем следующую неделю с учетом перехода через границу года
      if (weekNumber === 52 || weekNumber === 53) {
        // Проверяем, есть ли 53 неделя в этом году
        const testDate = this.getMondayOfWeek(53, year);
        if (testDate.getFullYear() === year) {
          // Есть 53 неделя
          if (weekNumber === 53) {
            return { weekNumber: 1, year: year + 1 };
          } else {
            return { weekNumber: 53, year: year };
          }
        } else {
          // Нет 53 недели, переходим в следующий год
          return { weekNumber: 1, year: year + 1 };
        }
      } else {
        return { weekNumber: weekNumber + 1, year: year };
      }
    },
    getPreviousWeek(weekNumber, year) {
      // Получаем предыдущую неделю с учетом перехода через границу года
      if (weekNumber === 1) {
        return { weekNumber: 52, year: year - 1 };
      } else {
        return { weekNumber: weekNumber - 1, year: year };
      }
    },
    getMondayOfWeek(weekNumber, year) {
      // Получаем понедельник указанной недели по ISO 8601
      // Первая неделя года - это неделя, содержащая 4 января
      const jan4 = new Date(year, 0, 4);
      const jan4Day = jan4.getDay();
      // Понедельник недели, содержащей 4 января
      const firstMonday = new Date(jan4);
      firstMonday.setDate(jan4.getDate() - (jan4Day === 0 ? 6 : jan4Day - 1));
      
      // Понедельник нужной недели
      const monday = new Date(firstMonday);
      monday.setDate(firstMonday.getDate() + (weekNumber - 1) * 7);
      monday.setHours(0, 0, 0, 0);
      
      return monday;
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
    },
    getDateForDay(dayName) {
      // Находим индекс дня недели в массиве weekDays
      const dayIndex = this.weekDays.indexOf(dayName);
      if (dayIndex === -1) {
        return '';
      }
      
      // Вычисляем дату этого дня на основе startDate (понедельник)
      const mondayDate = new Date(this.startDate);
      const dayDate = new Date(mondayDate);
      dayDate.setDate(mondayDate.getDate() + dayIndex);
      
      // Форматируем в формат "13 янв"
      const day = dayDate.getDate();
      const monthNames = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
      const month = monthNames[dayDate.getMonth()];
      
      return `${day} ${month}`;
    },
    formatDateForFilename(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const dayOfWeek = date.toLocaleDateString('ru-RU', { weekday: 'short' });
      return `${day}.${month.toString().padStart(2, '0')} (${dayOfWeek})`;
    },
    formatWeekPartRangeForFilename() {
      // Строит строку вроде: 29.10-31.10 (ср-пт)
      const selectedDays = this.computedSelectedDays;
      if (!selectedDays || selectedDays.length === 0) {
        // Фоллбэк на старое поведение
        const startD = new Date(this.startDate);
        const endD = new Date(this.endDate);
        const dd = (n) => n.toString().padStart(2, '0');
        const s = `${dd(startD.getDate())}.${dd(startD.getMonth() + 1)}`;
        const e = `${dd(endD.getDate())}.${dd(endD.getMonth() + 1)}`;
        const sw = startD.toLocaleDateString('ru-RU', { weekday: 'short' });
        const ew = endD.toLocaleDateString('ru-RU', { weekday: 'short' });
        return `${s}-${e} (${sw}-${ew})`;
      }

      const dayNumbers = selectedDays.sort((a, b) => a - b);

      // Базовая дата понедельника текущей недели берётся из startDate
      const monday = new Date(this.startDate);
      const firstDay = new Date(monday);
      const lastDay = new Date(monday);
      firstDay.setDate(monday.getDate() + dayNumbers[0]);
      lastDay.setDate(monday.getDate() + dayNumbers[dayNumbers.length - 1]);

      const dd = (n) => n.toString().padStart(2, '0');
      const firstStr = `${dd(firstDay.getDate())}.${dd(firstDay.getMonth() + 1)}`;
      const lastStr = `${dd(lastDay.getDate())}.${dd(lastDay.getMonth() + 1)}`;
      const firstW = firstDay.toLocaleDateString('ru-RU', { weekday: 'short' });
      const lastW = lastDay.toLocaleDateString('ru-RU', { weekday: 'short' });
      return `${firstStr}-${lastStr} (${firstW}-${lastW})`;
    },
    buildPdfFilename() {
      const shortDayNames = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];
      const sortedSelectedDays = [...this.computedSelectedDays].sort((a, b) => a - b);
      const firstDayIndex = sortedSelectedDays[0] ?? 0;
      const lastDayIndex = sortedSelectedDays[sortedSelectedDays.length - 1] ?? firstDayIndex;
      const daysSegment = `${shortDayNames[firstDayIndex]}_${shortDayNames[lastDayIndex]}`;

      const roomSegment = this.computedAllowedRoomTitles.length
        ? this.computedAllowedRoomTitles.map(room => this.normalizeRoomToken(room)).join('_')
        : 'БезПомещений';

      const baseDate = new Date(this.startDate);
      const firstDate = new Date(baseDate);
      firstDate.setDate(baseDate.getDate() + (sortedSelectedDays[0] ?? 0));
      const lastDate = new Date(baseDate);
      lastDate.setDate(baseDate.getDate() + (sortedSelectedDays[sortedSelectedDays.length - 1] ?? 0));

      const formatDatePart = (date) => `${date.getDate().toString().padStart(2, '0')}_${(date.getMonth() + 1).toString().padStart(2, '0')}`;

      return `${daysSegment}_${roomSegment}_${formatDatePart(firstDate)}__${formatDatePart(lastDate)}.pdf`;
    },
    normalizeRoomToken(roomTitle = '') {
      const chunks = roomTitle.split(/[^A-Za-zА-Яа-яЁё0-9№]+/).filter(Boolean);
      if (chunks.length === 0) {
        return 'Помещение';
      }
      return chunks.map(part => {
        if (!part.length) {
          return '';
        }
        const firstChar = part.charAt(0).toUpperCase();
        const rest = part.slice(1);
        return firstChar + rest;
      }).join('');
    },
    applySettings() {
      if (!this.schedule) {
        console.log('Schedule is null, skipping applySettings');
        return;
      }
      
      let filteredSchedule = this.schedule.filter(el => this.computedAllowedRoomTitles.includes(el.roomTitle));
      if (this.computedCommercialValue === 'commercial') {
        filteredSchedule = filteredSchedule.filter(el => el.exerciseTitle.includes('₽'));
      }
      if (this.computedCommercialValue === 'non-commercial') {
        filteredSchedule = filteredSchedule.filter(el => !el.exerciseTitle.includes('₽'));
      }
      if (this.computedKidValue === 'kid') {
        filteredSchedule = filteredSchedule.filter(el => el.exerciseTitle.includes('ДЕТИ'));
      }
      if (this.computedKidValue === 'non-kid') {
        filteredSchedule = filteredSchedule.filter(el => !el.exerciseTitle.includes('ДЕТИ'));
      }
      if (this.computedModeValue !== 'TV ближайшие') {
        // Используем выбранные дни недели вместо weekPart
        const allowedDays = this.computedSelectedDays;
        filteredSchedule = filteredSchedule.filter(el => allowedDays.includes(Number(el.dayOfWeekNumber)));
      }
      
      this.scheduleByHours = [];
      this.upcomingLessons = [];
      
        if (this.computedModeValue === '1/3 недели' || this.computedModeValue === '1/2 недели') {
        let result = {};
        const allowedDayNumbers = this.computedSelectedDays;
        const allowedDays = allowedDayNumbers.map(num => this.weekDays[num]);
        // Используем все выбранные дни недели, даже если в них нет занятий
        const usedDays = allowedDays;
        const usedRooms = [...new Set(filteredSchedule.map(el => el.roomTitle))].sort((a, b) => a.localeCompare(b));
        for (let hour = 7; hour <= 22; hour++) {
          result[hour] = {};
          usedDays.forEach(day => {
            if (!result[hour][day]) result[hour][day] = {};
            usedRooms.forEach(room => {
              const entries = filteredSchedule.filter(
                item => item.hour === hour && item.dayOfWeek === day && item.roomTitle === room
              );
              result[hour][day][room] = entries.length > 0 ? entries : null;
            });
          });
        }
        this.scheduleDays = usedDays;
        this.scheduleRooms = usedRooms;
        this.scheduleByHours = result;
      } else if (this.computedModeValue === 'TV ближайшие') {
        this.upcomingLessons = this.getUpcomingLessons(filteredSchedule);
      }
    },
    updateTvScaleFromWindowWidth() {
      // Автоматически определяем масштаб на основе ширины окна
      const width = window.innerWidth;
      if (width < 800) {
        this.tvScale = 0.25;
      } else if (width < 900) {
        this.tvScale = 0.5;
      } else if (width < 1200) {
        this.tvScale = 0.7;
      }
      // Для ширины >= 1200px оставляем текущее значение масштаба
      this.updateUrlFromState();
    },
    loadTvSchedule() {
      // Автоматически устанавливаем масштаб на основе ширины окна
      this.updateTvScaleFromWindowWidth();
      
      // Получаем текущую дату в московском времени
      const now = new Date();
      const moscowTime = new Date(now.toLocaleString("en-US", {timeZone: "Europe/Moscow"}));
      
      // Устанавливаем даты на сегодня и завтра
      const today = new Date(moscowTime);
      today.setHours(0, 0, 0, 0);
      
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      
      // Форматируем даты для API
      this.startDate = this.formatDateToISOStringWithoutMilliseconds(today);
      this.endDate = this.formatDateToISOStringWithoutMilliseconds(tomorrow);
      
      // Загружаем данные с кешем (кеш отобразится мгновенно, затем обновится в фоне)
      this.fetchData(false);
    },
    getUpcomingLessons(filteredSchedule) {
      // Получаем текущее московское время
      const now = new Date();
      const moscowTime = new Date(now.toLocaleString("en-US", {timeZone: "Europe/Moscow"}));
      
      // Получаем все тренировки и создаем объекты с датой и временем
      const allLessons = filteredSchedule.map(lesson => {
        const lessonDate = new Date(lesson.date);
        const [startHour, startMinute] = lesson.startTime.split(':').map(Number);
        
        // Создаем дату тренировки в московском времени
        const lessonDateTime = new Date(lessonDate);
        lessonDateTime.setHours(startHour, startMinute, 0, 0);
        
        return {
          ...lesson,
          lessonDateTime: lessonDateTime
        };
      });
      
      // Фильтруем только будущие тренировки (начиная с текущего времени)
      const upcomingLessons = allLessons
        .filter(lesson => lesson.lessonDateTime > moscowTime)
        .sort((a, b) => a.lessonDateTime - b.lessonDateTime)
        .slice(0, 30); // Показываем до 30 ближайших тренировок
      
      console.log('Московское время:', moscowTime.toLocaleString('ru-RU'));
      console.log('Найдено ближайших тренировок:', upcomingLessons.length);
      
      return upcomingLessons;
    },
    handleRoomButtonClick(item) {
      item.isActive = !item.isActive;
      this.applySettings();
      this.updateUrlFromState();
    },
    handleModeButtonClick(modeVal) {
      this.modes.forEach(m => m.isActive = m.val == modeVal);
      
      // Автоматически выбираем помещения в зависимости от режима
      this.updateRoomsForMode(modeVal);
      
      // Если выбран TV режим, загружаем расписание на сегодня и завтра
      if (modeVal === 'TV ближайшие') {
        // Автоматически устанавливаем масштаб на основе ширины окна
        this.updateTvScaleFromWindowWidth();
        this.loadTvSchedule();
        } else if (modeVal === '1/3 недели' || modeVal === '1/2 недели') {
          // Если переключаемся в режим "1/3 недели" или "1/2 недели", загружаем текущую неделю
          const weekInfo = this.getCurrentWeekNumber();
          this.weekNumber = weekInfo.weekNumber;
          this.year = weekInfo.year;
          this.setWeekStartEndDate(this.year, this.weekNumber);
          
          // Автоматически выбираем "Пн, Вт, Ср" (первый вариант)
          this.updateSelectedDaysFromWeekPart('0,1,2');
          
          this.fetchData(true);
        }
      
      this.applySettings();
      this.updateUrlFromState();
    },
    updateRoomsForMode(modeVal) {
      // Сбрасываем все помещения
      this.roomsSections.forEach(section => {
        section.rooms.forEach(room => room.isActive = false);
      });
      
      if (modeVal === '1/2 недели' || modeVal === '1/3 недели') {
        // Для режимов 1/2 и 1/3 недели: выбираем только Зал 1 и Зал 2
        this.roomsSections.forEach(section => {
          section.rooms.forEach(room => {
            if (room.title === 'Зал №1' || room.title === 'Зал №2') {
              room.isActive = true;
            }
          });
        });
      } else if (modeVal === 'TV ближайшие') {
        // Для режима TV: выбираем все помещения кроме Малого Бассейна
        this.roomsSections.forEach(section => {
          section.rooms.forEach(room => {
            if (room.title !== 'Малый Бассейн') {
              room.isActive = true;
            }
          });
        });
      }
    },
    handleCommercialButtonClick(commercialVal) {
      this.commercials.forEach(c => c.isActive = c.val == commercialVal);
      this.applySettings();
    },
    handleKidButtonClick(kidVal) {
      this.kids.forEach(k => k.isActive = k.val == kidVal);
      this.applySettings();
    },
    handleDayButtonClick(dayVal) {
      // Переключаем состояние кнопки дня
      const dayButton = this.weekDaysButtons.find(day => day.val === dayVal);
      if (dayButton) {
        dayButton.isActive = !dayButton.isActive;
        this.applySettings();
        this.updateUrlFromState();
      }
    },
    handleTvLessonsPerRowClick(count) {
      this.tvLessonsPerRow = count;
      this.updateUrlFromState();
    },
    handleTvScaleClick(scale) {
      this.tvScale = scale;
      this.updateUrlFromState();
    },
    // Функции для работы со снежинками (решение из Доки)
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getRndFloat(min, max) {
      return (Math.random() * (max - min) + min).toFixed(1);
    },
    startSnowflakes() {
      // Устанавливаем анимацию
      this.snowAnimationName = 'snowfall';
      
      // Настраиваем каждую снежинку после монтирования DOM (как в решении из Доки)
      this.$nextTick(() => {
        const snowContainer = document.querySelector('.snow');
        if (snowContainer) {
          const snowflakes = snowContainer.querySelectorAll('.snow__flake');
          console.log('Найдено снежинок:', snowflakes.length);
          const containerWidth = window.innerWidth;
          const containerHeight = window.innerHeight;
          snowflakes.forEach((snowflake) => {
            // Случайный размер (от 20px до 40px для лучшей видимости)
            const size = this.getRndFloat(20, 40);
            snowflake.style.fontSize = size + 'px';
            // Случайная позиция по X
            snowflake.style.left = (Math.random() * containerWidth) + 'px';
            // Начальная позиция по Y - сверху экрана
            snowflake.style.top = '-50px';
            // Случайная начальная позиция для transform (чтобы некоторые уже были видны)
            const startYOffset = Math.random() * containerHeight - 100;
            // Устанавливаем начальную позицию через transform
            snowflake.style.transform = `translateY(${startYOffset}px)`;
            // Случайная скорость падения (от 8 до 20 секунд)
            const duration = this.getRndInteger(8, 20);
            snowflake.style.animationDuration = duration + 's';
            // Случайная задержка (от -10 до 0 секунд, чтобы сразу начать)
            snowflake.style.animationDelay = this.getRndInteger(-10, 0) + 's';
            // Устанавливаем анимацию напрямую
            snowflake.style.animationName = 'snowfall';
            snowflake.style.animationTimingFunction = 'linear';
            snowflake.style.animationIterationCount = 'infinite';
            snowflake.style.animationFillMode = 'forwards';
            // Убедимся, что элемент виден
            snowflake.style.display = 'block';
            snowflake.style.visibility = 'visible';
          });
        } else {
          console.error('Контейнер .snow не найден!');
        }
      });
    },
    stopSnowflakes() {
      // Останавливаем анимацию
      this.snowAnimationName = 'none';
    },
    handleWeekPartButtonClick(wpVal) {
      // Если выбрана "Вся неделя", запускаем генерацию всех PDF
      if (wpVal === '0,1,2,3,4,5,6') {
        this.generateAllPDFs();
        return;
      }
      
      // Активируем соответствующие кнопки дней недели
      this.updateSelectedDaysFromWeekPart(wpVal);
      
      this.applySettings();
      this.updateUrlFromState();
    },
    updateSelectedDaysFromWeekPart(wpVal) {
      // Сбрасываем все кнопки дней
      this.weekDaysButtons.forEach(day => day.isActive = false);
      
      // Активируем соответствующие дни
      const dayNumbers = wpVal.split(',').map(str => parseInt(str.trim()));
      dayNumbers.forEach(dayNum => {
        const dayButton = this.weekDaysButtons.find(day => day.val === dayNum);
        if (dayButton) {
          dayButton.isActive = true;
        }
      });
    },
    forceRefresh() {
      // Принудительное обновление данных и кэша для выбранной недели
      this.fetchData(true);
    },
    async generatePDF() {
      this.excerciseTitleFontSize = '22.5pt'; // Reduced from 25pt to 22.5pt (10% reduction)
      this.weekdayHeaderFontSize = '25pt';
      this.roomHeaderTitleFontSize = '25pt';
      const printingContent = document.getElementById('printingContent');
      const contentCenter = document.getElementById('contentCenter');
      const contentRight = document.getElementById('contentRight');
      const oldWidthPrintingContent = printingContent.offsetWidth;
      const A4_WIDTH = 297;
      const A4_HEIGHT = 210;
      const a4AspectRatio = A4_WIDTH / A4_HEIGHT;
      const newWidthPrintingContent = printingContent.offsetHeight * a4AspectRatio;
      if (newWidthPrintingContent > oldWidthPrintingContent)
        printingContent.style.width = newWidthPrintingContent + 'px';
      let contentCenterWidth = Math.floor(printingContent.offsetWidth * (100 - this.paddingRightPercent) / 100);
      let contentRightWidth = Math.ceil(printingContent.offsetWidth * (this.paddingRightPercent) / 100);
      contentCenter.style.width = contentCenterWidth + 'px';
      contentRight.style.width = contentRightWidth + 'px';
      const canvas = await html2canvas(printingContent);
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: [printingContent.offsetWidth, printingContent.offsetHeight]
      });
      pdf.addImage(canvas.toDataURL('image/jpeg'), 'JPEG', 0, 0, printingContent.offsetWidth, printingContent.offsetHeight);
      const fileName = this.buildPdfFilename();
      pdf.save(fileName);
      printingContent.style.width = oldWidthPrintingContent + 'px';
      contentCenter.style.width = oldWidthPrintingContent + 'px';
      contentRight.style.width = '0 px';
      this.excerciseTitleFontSize = '18pt'; // Restore to reduced size
      this.weekdayHeaderFontSize = '20pt';
      this.roomHeaderTitleFontSize = '20pt';
    },
    async generateAllPDFs() {
      // Определяем комбинации дней недели в зависимости от текущего режима
      let weekPartsCombinations;
      if (this.computedModeValue === '1/2 недели') {
        weekPartsCombinations = [
          { title: 'Пн, Вт, Ср', val: '0,1,2' },
          { title: 'Чт, Пт, Сб, Вс', val: '3,4,5,6' }
        ];
      } else {
        // Для режима "1/3 недели"
        weekPartsCombinations = [
          { title: 'Пн, Вт, Ср', val: '0,1,2' },
          { title: 'Ср, Чт, Пт', val: '2,3,4' },
          { title: 'Пт, Сб, Вс', val: '4,5,6' }
        ];
      }

      let roomsCombinations;
      if (this.computedKidValue === 'kid') {
        // Для "Дети" печатаем по детским группам помещений.
        roomsCombinations = [
          {
            title: 'Бассейны',
            rooms: [
              { isActive: true, title: 'Аква зона' },
              { isActive: true, title: 'Малый бассейн' }
            ]
          },
          {
            title: 'Сухой детский 1',
            rooms: [
              { isActive: true, title: 'Зал единоборств (ДЕТИ)' },
              { isActive: true, title: 'Зона кроссфита' }
            ]
          },
          {
            title: 'Сухой детский 2',
            rooms: [
              { isActive: true, title: 'Студия 1 (ДЕТИ)' },
              { isActive: true, title: 'Эстетический зал (ДЕТИ)' }
            ]
          }
        ];
      } else {
        // Текущее поведение оставляем для взрослых (и остальных режимов фильтра).
        roomsCombinations = [
          {
            title: 'ТЗ и студии',
            rooms: [
              { isActive: true, title: 'Тренажерный зал' },
              { isActive: true, title: 'Студия пилатес' }
            ]
          },
          {
            title: 'Кроссфит и единоборства',
            rooms: [
              { isActive: true, title: 'Зона кроссфита' },
              { isActive: true, title: 'Зона единоборств' }
            ]
          },
          {
            title: 'Групповые программы',
            rooms: [
              { isActive: true, title: 'Зал №1' },
              { isActive: true, title: 'Зал №2' }
            ]
          },
          {
            title: 'Сайкл',
            rooms: [
              { isActive: true, title: 'Сайкл студия' },
              { isActive: true, title: 'Студия йоги' }
            ]
          },
          {
            title: 'Бассейны',
            rooms: [
              { isActive: true, title: 'Аква зона' }
            ]
          }
        ];
      }

      // Сохраняем текущие настройки
      const originalSelectedDays = [...this.computedSelectedDays];
      const originalRoomsSections = JSON.parse(JSON.stringify(this.roomsSections));

      // Устанавливаем флаг генерации
      this.isGeneratingAllPDFs = true;
      this.pdfGenerationProgress = 0;

      const totalFiles = weekPartsCombinations.length * roomsCombinations.length;
      console.log(`Начинаем генерацию ${totalFiles} PDF файлов для режима "${this.computedModeValue}"...`);

      let currentFile = 1;

      try {
        // Генерируем PDF для каждой комбинации
        for (const weekPart of weekPartsCombinations) {
          for (const roomsSection of roomsCombinations) {
            console.log(`Генерируем файл ${currentFile}/${totalFiles}: ${weekPart.title} - ${roomsSection.title}`);

            // Устанавливаем текущую комбинацию дней недели
            this.updateSelectedDaysFromWeekPart(weekPart.val);
            
            // Устанавливаем текущую комбинацию помещений
            this.roomsSections.forEach(section => {
              section.rooms.forEach(room => room.isActive = false);
            });
            
            // Активируем помещения для текущей комбинации
            roomsSection.rooms.forEach(roomToActivate => {
              this.roomsSections.forEach(section => {
                section.rooms.forEach(room => {
                  if (room.title === roomToActivate.title) {
                    room.isActive = true;
                  }
                });
              });
            });

            // Применяем настройки и генерируем PDF
            this.applySettings();
            
            // Небольшая задержка для обновления DOM
            await new Promise(resolve => setTimeout(resolve, 100));
            
            await this.generatePDF();

            // Обновляем прогресс
            this.pdfGenerationProgress = Math.round((currentFile / totalFiles) * 100);
            currentFile++;
          }
        }

        console.log('Генерация всех PDF файлов завершена!');

      } catch (error) {
        console.error('Ошибка при генерации PDF:', error);
        alert('Произошла ошибка при генерации PDF файлов');
      } finally {
        // Восстанавливаем оригинальные настройки
        this.roomsSections = originalRoomsSections;
        // Восстанавливаем оригинальные дни недели
        this.updateSelectedDaysFromWeekPart(originalSelectedDays.join(','));
        this.applySettings();
        
        // Сбрасываем флаг генерации
        this.isGeneratingAllPDFs = false;
        this.pdfGenerationProgress = 0;
      }
    },
    async fetchData(force = false) {
      try {
        const isTvMode = this.computedModeValue === 'TV ближайшие';
        if (!isTvMode) {
          this.isLoading = true;
        }

        // Для TV режима всегда грузим расписание: сегодня 00:00:00 -> сегодня+7 дней 23:59:59
        // независимо от this.startDate/this.endDate (они могут относиться к неделе и/или быть в URL).
        let apiStartDate = this.startDate;
        let apiEndDate = this.endDate;
        if (isTvMode) {
          const todayStart = new Date();
          todayStart.setHours(0, 0, 0, 0);

          const end = new Date(todayStart);
          end.setDate(end.getDate() + 7);
          end.setHours(23, 59, 59, 0);

          apiStartDate = this.formatDateToISOStringWithoutMilliseconds(todayStart);
          apiEndDate = this.formatDateToISOStringWithoutMilliseconds(end);
        }
        
        if (isTvMode) {
          let hasRenderedData = false;

          // Шаг 0: Показываем локальный браузерный кэш мгновенно (если есть)
          const localCache = this.readTvScheduleCache(apiStartDate, apiEndDate);
          if (localCache && localCache.data.length > 0) {
            this.applyTvScheduleData(localCache.data, `TV: показан локальный кэш браузера (${localCache.fetchedAtHuman || 'время неизвестно'})`);
            hasRenderedData = true;
          }

          // Шаг 1: Пытаемся получить кэш сервера (быстрый путь)
          try {
            console.log('TV: загрузка из серверного кэша...');
            const cacheResponse = await axios.get(
              `${process.env.VUE_APP_API_URL}/schedule/current?startDate=${apiStartDate}&endDate=${apiEndDate}&useCache=true&mode=TV`,
              { timeout: 12000 }
            );
            const cachedData = cacheResponse?.data?.data || [];
            if (Array.isArray(cachedData) && cachedData.length > 0) {
              this.applyTvScheduleData(cachedData, `TV: загружено из серверного кэша (${cacheResponse.data.fetchedAtHuman})`);
              this.writeTvScheduleCache(apiStartDate, apiEndDate, cachedData, cacheResponse.data.fetchedAtHuman);
              hasRenderedData = true;
            }
          } catch (error) {
            console.error('TV: не удалось загрузить серверный кэш', error);
          }

          // Шаг 2: Обновляем свежие данные с сервера
          const refreshTask = async () => {
            const freshResponse = await axios.get(
              `${process.env.VUE_APP_API_URL}/schedule/current?startDate=${apiStartDate}&endDate=${apiEndDate}&useCache=false&mode=TV`,
              { timeout: 45000 }
            );
            const freshData = freshResponse?.data?.data || [];
            this.applyTvScheduleData(freshData, `TV: данные обновлены (${freshResponse.data.fetchedAtHuman})`);
            this.writeTvScheduleCache(apiStartDate, apiEndDate, freshData, freshResponse.data.fetchedAtHuman);
          };

          if (force) {
            try {
              await refreshTask();
              hasRenderedData = true;
            } catch (error) {
              console.error('TV: ошибка при принудительном обновлении данных', error);
            }
          } else {
            this.isUpdatingInBackground = true;
            setTimeout(async () => {
              try {
                await refreshTask();
              } catch (error) {
                console.error('TV: ошибка при фоновом обновлении данных', error);
              } finally {
                this.isUpdatingInBackground = false;
              }
            }, 100);
          }

          if (!hasRenderedData) {
            console.warn('TV: нет данных ни в локальном, ни в серверном кэше — оставляем текущее отображение без очистки');
          }
          return;
        }
        
        if (!isTvMode) {
          let hasRenderedData = false;
          const baseUrl = `${process.env.VUE_APP_API_URL}/schedule/current?startDate=${apiStartDate}&endDate=${apiEndDate}`;
          const applyNonTvScheduleData = (payload = {}, sourceLabel = '') => {
            const data = Array.isArray(payload.data) ? payload.data : [];
            this.schedule = data;
            this.rooms = [...new Set(this.schedule.map(item => item.roomTitle))].sort().map(el => { return { isActive: false, title: el } });
            this.applySettings();
            this.updateUrlFromState();
            if (sourceLabel) {
              console.log(sourceLabel);
            }
          };

          // На обычной загрузке сначала быстро показываем серверный кэш
          if (!force) {
            try {
              const cachedResponse = await axios.get(`${baseUrl}&useCache=true`, { timeout: 12000 });
              applyNonTvScheduleData(cachedResponse.data, `Показаны кэшированные данные (${cachedResponse.data.fetchedAtHuman})`);
              hasRenderedData = true;
            } catch (cacheError) {
              console.warn('Не удалось быстро получить кэш для обычного режима:', cacheError);
            }
          }

          // Затем всегда пытаемся получить свежие данные
          try {
            const freshResponse = await axios.get(`${baseUrl}&useCache=false`, { timeout: 45000 });
            applyNonTvScheduleData(freshResponse.data, `Обновлено ${freshResponse.data.fetchedAtHuman}`);
            hasRenderedData = true;
          } catch (freshError) {
            console.error('Ошибка при получении свежих данных для обычного режима:', freshError);

            // Если свежие данные недоступны и на экране ничего нет, пробуем повторно взять кэш
            if (!hasRenderedData) {
              try {
                const fallbackCacheResponse = await axios.get(`${baseUrl}&useCache=true`, { timeout: 12000 });
                applyNonTvScheduleData(fallbackCacheResponse.data, `Показан fallback-кэш (${fallbackCacheResponse.data.fetchedAtHuman})`);
                hasRenderedData = true;
              } catch (fallbackError) {
                console.error('Fallback на кэш для обычного режима тоже не удался:', fallbackError);
              }
            }
          }

          if (!hasRenderedData) {
            console.warn('Обычный режим: не удалось получить данные ни из свежего источника, ни из кэша');
          }
        }
      } catch (error) {
        console.error('Ошибка при получении данных:', error);
      } finally {
        if (this.computedModeValue !== 'TV ближайшие') {
          this.isLoading = false;
        }
      }
    },
    updateUrlFromState() {
      try {
        const params = new URLSearchParams(window.location.search);
        
        // mode (режим отображения)
        const activeMode = this.modes.find(mode => mode.isActive);
        if (activeMode) params.set('mode', activeMode.val);
        
        // fullScreenMode (состояние панели настроек)
        params.set('fullScreen', this.fullScreenMode.toString());
        
        // weekPart
        const activeWeekPart = this.weekParts.find(wp => wp.isActive);
        if (activeWeekPart) params.set('weekPart', activeWeekPart.val);
        
        // selectedDays (выбранные дни недели)
        const selectedDays = this.computedSelectedDays;
        if (selectedDays.length > 0) {
          params.set('selectedDays', selectedDays.join(','));
        } else {
          params.delete('selectedDays');
        }

        // tvLessonsPerRow (количество занятий в строке для TV режима)
        params.set('tvLessonsPerRow', this.tvLessonsPerRow.toString());
        
        // tvScale (масштаб для TV режима)
        params.set('tvScale', this.tvScale.toString());
        
        // rooms (из roomsSections только активные)
        const activeRooms = [];
        this.roomsSections.forEach(section => {
          section.rooms.filter(r => r.isActive).forEach(r => activeRooms.push(r.title));
        });
        if (activeRooms.length > 0) {
          params.set('rooms', activeRooms.join(','));
        } else {
          params.delete('rooms');
        }
        
        // диапазон дат недели
        params.set('startDate', this.startDate);
        params.set('endDate', this.endDate);
        
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, '', newUrl);
      } catch (e) {
        console.warn('Не удалось обновить URL из состояния', e);
      }
    },
    restoreStateFromUrl(skipDates = false) {
      try {
        const params = new URLSearchParams(window.location.search);
        const urlMode = params.get('mode');
        const urlWeekPart = params.get('weekPart');
        const urlSelectedDays = params.get('selectedDays');
        const urlRooms = params.get('rooms');
        const urlStart = params.get('startDate');
        const urlEnd = params.get('endDate');
        const urlFullScreen = params.get('fullScreen');
        const urlTvLessonsPerRow = params.get('tvLessonsPerRow');
        const urlTvScale = params.get('tvScale');

        // Восстанавливаем даты из URL только если skipDates = false
        if (!skipDates && urlStart && urlEnd) {
          this.startDate = urlStart;
          this.endDate = urlEnd;
        }

        // Восстанавливаем состояние панели настроек
        if (urlFullScreen !== null) {
          this.fullScreenMode = urlFullScreen === 'true';
        }

        // Восстанавливаем количество занятий в строке для TV режима
        if (urlTvLessonsPerRow) {
          const count = parseInt(urlTvLessonsPerRow);
          if (!isNaN(count) && count >= 1 && count <= 6) {
            this.tvLessonsPerRow = count;
          }
        }

        // Восстанавливаем масштаб для TV режима только если режим не TV
        // В TV режиме масштаб устанавливается автоматически на основе ширины окна
        if (urlTvScale && urlMode !== 'TV ближайшие') {
          const scale = parseFloat(urlTvScale);
          if (!isNaN(scale) && scale >= 0.5 && scale <= 2.0) {
            this.tvScale = scale;
          }
        }

        // Восстанавливаем режим отображения
        if (urlMode) {
          this.modes.forEach(mode => mode.isActive = (mode.val === urlMode));
        }

        // Определяем текущий активный режим (из URL или по умолчанию)
        const currentMode = urlMode || this.computedModeValue;

        // Автоматически выбираем помещения в зависимости от режима (если помещения не указаны в URL)
        if (!urlRooms) {
          this.updateRoomsForMode(currentMode);
        }

        // Восстанавливаем фильтры из URL (в первую очередь)
        if (urlRooms) {
          const wanted = new Set(urlRooms.split(',').map(s => s.trim()).filter(Boolean));
          this.roomsSections.forEach(section => {
            section.rooms.forEach(r => { r.isActive = wanted.has(r.title); });
          });
        }

        // Восстанавливаем выбранные дни недели
        if (urlSelectedDays) {
          const selectedDayNumbers = urlSelectedDays.split(',').map(s => parseInt(s.trim())).filter(n => !isNaN(n));
          this.weekDaysButtons.forEach(day => {
            day.isActive = selectedDayNumbers.includes(day.val);
          });
        }

        // Восстанавливаем weekPart только если НЕ TV режим
        if (urlWeekPart && urlMode !== 'TV ближайшие') {
          this.weekParts.forEach(wp => wp.isActive = (wp.val === urlWeekPart));
        }

        // Применяем настройки
        this.applySettings();

        // Загружаем данные в зависимости от режима
        if (currentMode === 'TV ближайшие') {
          // В TV режиме автоматически устанавливаем масштаб на основе ширины окна
          this.updateTvScaleFromWindowWidth();
          this.loadTvSchedule();
        } else if (currentMode === '1/3 недели' || currentMode === '1/2 недели') {
          // Если переключаемся в режим "1/3 недели" или "1/2 недели", загружаем текущую неделю
          const weekInfo = this.getCurrentWeekNumber();
          this.weekNumber = weekInfo.weekNumber;
          this.year = weekInfo.year;
          this.setWeekStartEndDate(this.year, this.weekNumber);
          
          // Если нет выбранных дней в URL, автоматически выбираем "Пн, Вт, Ср"
          if (!urlSelectedDays) {
            this.updateSelectedDaysFromWeekPart('0,1,2');
          }
          
          this.fetchData(true);
        }
      } catch (e) {
        console.warn('Не удалось восстановить состояние из URL', e);
      }
    }
  },
  props: {}
}
</script>

<style scoped>
#contentCenter {
  padding: 2px;
  border-right: 1px dashed rgb(131, 130, 130);
}
.full-screen-button {
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  height: 27px;
  width: 27px;
}
.logo-btn {
  padding: 0;
  height: 40px;
  width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.g1logo {
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.room-button {
  padding: 5px;
  font-size: 11pt;
}
button {
  border-radius: 0;
  font-weight: bold;
  border-color: #f33;
  color: #333;
  border: 1px solid #f33;
}
button.active,
button:hover {
  font-weight: bold;
  transition: background-color 0.3s ease;
  background-color: #f33;
  border-color: #333;
  color: #fff;
}
.list-group {
  border-radius: 0;
}
.list-group-item:hover,
.list-group-item.active {
  font-weight: bold;
  transition: background-color 0.3s ease;
  background-color: #f33;
  border-color: #333;
  color: #fff;
}
.filter-block {
  padding: 0px;
}
.filter-title {
  padding-left: 5px;
  font-size: 10pt;
}
.filter-button {
  text-align: center;
  font-size: 12pt;
}
.ruble-icon {
  position: absolute;
  bottom: 3px;
  right: 7px;
}
.line-height-1-2 {
  line-height: 1.2;
}
.lesson-parent {
  font-size: v-bind(fontSizeVW);
}
.weekday-header {
  font-size: v-bind(weekdayHeaderFontSize);
  font-weight: bold;
}
.room-header {
  font-size: v-bind(roomHeaderTitleFontSize);
  text-align: center;
}
.exercise-title {
  font-size: v-bind(excerciseTitleFontSize);
  text-align: left;
  margin-left: 6px;
  font-weight: bold;
}
.trainer-name {
  font-size: 15pt;
  width: 100%;
  text-align: left;
  margin-left: 6px;
}
.start-end-time {
  width: 100%;
  text-align: left;
  margin-left: 6px;
}
.room-title {
  width: 100%;
  text-align: left;
  margin-left: 6px;
}
.td-container {
  padding: 0;
  height: 100%;
  position: relative;
}
.inner-div {
  height: 100%;
}
.lesson-parent {
  position: relative;
  border-radius: 10px;
  padding-left: 20px;
  padding-right: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
  background-color: #f0f0f0;
}
.lesson-color {
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 100%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.clock-column-style {
  font-size: 30px;
  width: 60px !important;
  min-width: 60px !important;
  max-width: 60px !important;
}
.clock-button {
  background: none;
  border: 1px solid #f33;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border-radius: 4px;
}
.clock-button:hover {
  background-color: rgba(255, 51, 51, 0.1);
  transform: scale(1.05);
  border-color: #333;
}
.clock-button:active {
  background-color: rgba(255, 51, 51, 0.2);
  transform: scale(0.95);
  border-color: #333;
}
.day-group-bg-0 {
  background-color: #ffffff;
}
.day-group-bg-1 {
  background-color: #f5f5f5;
}
.day-separator {
  border-right: 2px solid #a0a0a0;
}
.head-separator {
  border-bottom: 2px solid #a0a0a0;
}
.tv-mode-table {
  font-size: 1.2em;
}
.tv-mode-table .exercise-title {
  font-size: 24pt;
  font-weight: bold;
}
.tv-mode-table .trainer-name {
  font-size: 18pt;
}
.tv-mode-table .start-end-time {
  font-size: 16pt;
}
.tv-mode-table .room-title {
  font-size: 16pt;
  font-weight: bold;
  color: #666;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 16px;
  padding: 28px 40px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  font-size: 1.1rem;
  color: #333;
}
.tv-clock-column-style {
  font-size: 30px;
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
}
.tv-clock-button {
  background: none;
  border: 1px solid #f33;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border-radius: 4px;
  min-height: 60px;
}
.tv-clock-button:hover {
  background-color: rgba(255, 51, 51, 0.1);
  transform: scale(1.05);
  border-color: #333;
}
.tv-clock-button:active {
  background-color: rgba(255, 51, 51, 0.2);
  transform: scale(0.95);
  border-color: #333;
}

/* Новый дизайн TV режима */
.tv-mode-container {
  position: relative;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
  overflow: hidden;
}

  .tv-header {
    position: relative;
    z-index: 20;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 2px solid #dee2e6;
    height: 60px; /* Высота как у кнопки "Настройки" */
  }

.tv-title-section {
  flex: 1;
}

.tv-main-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin: 0 0 10px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tv-subtitle {
  font-size: 1.2rem;
  color: #6c757d;
  font-weight: 300;
}

.tv-control-button {
  background: white;
  border: 1px solid #f33;
  border-radius: 8px;
  padding: 5px 15px;
  color: #f33;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  height: 60px;
}

.tv-control-button:hover {
  background: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(255, 51, 51, 0.2);
}

.tv-control-button:active {
  transform: translateY(0);
}

.tv-control-text {
  font-size: 1rem;
}

.g1-logo-button {
  max-height: 100%;
  width: auto;
  object-fit: contain;
  display: block;
}

.tv-lessons-wrapper {
  position: relative;
  z-index: 20;
  margin: 0 auto;
}

.tv-lessons-container {
  min-height: 400px;
  width: 100%;
}

.tv-no-lessons {
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
}

.tv-no-lessons h3 {
  margin: 20px 0 10px 0;
  font-size: 1.5rem;
}

.tv-no-lessons p {
  font-size: 1.1rem;
  margin: 0;
}

  .tv-lessons-grid {
    display: grid;
    grid-template-columns: repeat(v-bind(tvLessonsPerRow), 1fr);
    gap: 20px;
    width: 100%;
  }

.tv-lesson-card {
  background: white;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.tv-lesson-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.tv-lesson-time {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
  background: linear-gradient(135deg, #f33 0%, #d32f2f 100%);
  color: white;
  border-radius: 10px;
  min-width: 80px;
}

.tv-time-main {
  font-size: 1.5rem;
  font-weight: bold;
}

.tv-time-duration {
  font-size: 0.9rem;
  opacity: 0.9;
}

.tv-lesson-content {
  flex: 1;
}

.tv-lesson-title {
  font-size: 1.3rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 8px;
  line-height: 1.3;
}

.tv-lesson-trainer {
  font-size: 1.1rem;
  color: #495057;
  margin-bottom: 5px;
  font-weight: 500;
}

.tv-lesson-date {
  font-size: 1rem;
  color: #6c757d;
  margin-bottom: 5px;
}

.tv-lesson-room {
  font-size: 1rem;
  color: #f33;
  font-weight: bold;
  background: rgba(255, 51, 51, 0.1);
  padding: 5px 10px;
  border-radius: 20px;
  display: inline-block;
}

.tv-lesson-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 8px;
  height: 100%;
}

.tv-ruble-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  background: #ffd700;
  color: #333;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: bold;
}

/* Стили для эффекта падающих снежинок */
/* Стили для снежинок (решение из Доки) */
.snow {
  --animation-name: snowfall;
  position: fixed !important;
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  z-index: 9999 !important;
  pointer-events: none;
  overflow: visible;
  width: 100vw !important;
  height: 100vh !important;
}

.snow__flake {
  position: absolute !important;
  top: -50px;
  color: #c8e6ff !important;
  font-size: 24px !important;
  line-height: 1;
  text-shadow: 0 0 10px rgba(200, 230, 255, 1), 0 0 20px rgba(170, 220, 255, 0.9), 0 0 30px rgba(150, 210, 255, 0.7);
  animation-name: snowfall !important;
  animation-timing-function: linear !important;
  animation-iteration-count: infinite !important;
  will-change: transform;
  user-select: none;
  pointer-events: none;
  opacity: 1 !important;
  font-weight: bold;
  display: block !important;
  visibility: visible !important;
}

@keyframes snowfall {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(calc(100vh + 350px));
    opacity: 0.9;
  }
}
</style>